module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Edit-text-9c7ed4219b2f36ad790cf25d4ec0a19d.svg";